module.exports = __webpack_public_path__ + "media/images/prizes/title-83d4b5c8142dd2248d87ed86ed5a4cbc.png";